<aside class="sidebar">
  

  <div class="restaurant-block">
    <div class="restaurant-logo">
      R
    </div>

    <div class="restaurant-details">
      <strong>რესტორანი</strong>
      <span>მართვის პანელი</span>
    </div>
  </div>

  <nav class="sidebar-nav">
    <!-- <a
      [routerLink]="['/']"

    >
      <span class="menu-icon">⌂</span>
      <span>მთავარი</span>
    </a> -->

    <a
      [routerLink]="['/app/orders', appId]"
      routerLinkActive="active"
    >
      <span class="menu-icon">▣</span>
      <span>შეკვეთები</span>
    </a>

    <a
      [routerLink]="['/app/products', appId]"
      routerLinkActive="active"
    >
      <span class="menu-icon">☷</span>
      <span>პროდუქტები</span>
    </a>

    <a
      [routerLink]="['/app/languages', appId]"
      routerLinkActive="active"
    >
      <span class="menu-icon">◎</span>
      <span>ენები</span>
    </a>

    <a
      [routerLink]="['/app/analitic', appId]"
      routerLinkActive="active"
    >
      <span class="menu-icon">▥</span>
      <span>ანალიტიკა</span>
    </a>

    <a
      [routerLink]="['/app/setting', appId]"
      routerLinkActive="active"
    >
      <span class="menu-icon">⚙</span>
      <span>პარამეტრები</span>
    </a>
  </nav>

  <div class="sidebar-footer">
    <button type="button" (click)="changeRestaurant()">
      <span>←</span>

      <span>
        <strong>რესტორნის შეცვლა</strong>
        <small>სხვა სივრცის არჩევა</small>
      </span>
    </button>
  </div>
</aside>